import api from './api';

export interface MeetingMedication {
  id: number;
  meeting_id: number;
  medication_type_id: number | null;
  dosage_amount: number | null;
  dosage_unit: string | null;
  freq_amount: number | null;
  freq_period: string | null;
  duration_in_days: number | null;
  dosage_instructions: string | null;
  quantity: number | null;
  comments: string | null;
  created_at: string;
  updated_at: string;
}

export interface MeetingMedicationCreate {
  meeting_id: number;
  medication_type_id?: number | null;
  dosage_amount?: number | null;
  dosage_unit?: string | null;
  freq_amount?: number | null;
  freq_period?: string | null;
  duration_in_days?: number | null;
  dosage_instructions?: string | null;
  quantity?: number | null;
  comments?: string | null;
}

export interface MeetingMedicationUpdate {
  medication_type_id?: number | null;
  dosage_amount?: number | null;
  dosage_unit?: string | null;
  freq_amount?: number | null;
  freq_period?: string | null;
  duration_in_days?: number | null;
  dosage_instructions?: string | null;
  quantity?: number | null;
  comments?: string | null;
}

export const meetingMedicationService = {
  async getMeetingMedications(meetingId: number): Promise<MeetingMedication[]> {
    const response = await api.get(`/meetings/${meetingId}/medications`);
    return response.data;
  },

  async createMeetingMedication(meetingId: number, data: MeetingMedicationCreate): Promise<MeetingMedication> {
    const response = await api.post(`/meetings/${meetingId}/medications`, data);
    return response.data;
  },

  async updateMeetingMedication(id: number, data: MeetingMedicationUpdate): Promise<MeetingMedication> {
    const response = await api.put(`/meeting-medications/${id}`, data);
    return response.data;
  },

  async deleteMeetingMedication(id: number): Promise<void> {
    await api.delete(`/meeting-medications/${id}`);
  },
};
